const Undo = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3601_17473)">
      <path
        d="M1.99811 12.8565H1.55661V12.415V9.76605C1.55661 9.64896 1.51009 9.53666 1.42729 9.45386C1.3445 9.37106 1.2322 9.32455 1.11511 9.32455C0.998013 9.32455 0.885716 9.37106 0.80292 9.45386C0.720122 9.53666 0.673607 9.64896 0.673607 9.76605V12.415C0.673607 12.7663 0.813152 13.1032 1.06154 13.3516C1.30994 13.6 1.64683 13.7395 1.99811 13.7395H12.5941C12.9454 13.7395 13.2823 13.6 13.5307 13.3516C13.7791 13.1032 13.9186 12.7663 13.9186 12.415V6.23405C13.9186 5.88277 13.7791 5.54588 13.5307 5.29749C13.2823 5.04909 12.9454 4.90955 12.5941 4.90955H4.12967H3.06379L3.81748 4.15586L5.83901 2.13434C5.91805 2.05132 5.96174 1.94077 5.96074 1.82606C5.95973 1.7103 5.9133 1.59957 5.83144 1.51771C5.74959 1.43585 5.63885 1.38942 5.52309 1.38842C5.40839 1.38742 5.29784 1.43111 5.21482 1.51015L1.68606 5.03891C1.60329 5.1217 1.5568 5.23398 1.5568 5.35105C1.5568 5.46812 1.60329 5.5804 1.68606 5.66319L5.21801 9.19514L5.21806 9.1951L5.22339 9.20061C5.26412 9.24278 5.31284 9.27642 5.3667 9.29956L5.19244 9.70521L5.3667 9.29956C5.42057 9.32269 5.4785 9.33487 5.53712 9.33538C5.59574 9.33589 5.65388 9.32472 5.70814 9.30252C5.7624 9.28032 5.81169 9.24754 5.85315 9.20609C5.8946 9.16463 5.92738 9.11534 5.94958 9.06108C5.97178 9.00682 5.98295 8.94868 5.98244 8.89006C5.98193 8.83144 5.96975 8.77351 5.94661 8.71964L6.35227 8.54539L5.94661 8.71964C5.92348 8.66578 5.88984 8.61706 5.84767 8.57633L5.84763 8.57638L5.8422 8.57096L3.81748 6.54624L3.06379 5.79255H4.12967H12.5941H13.0356V6.23405V12.415V12.8565H12.5941H1.99811Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.883"
      />
    </g>
    <defs>
      <clipPath id="clip0_3601_17473">
        <rect
          width="14.128"
          height="14.128"
          fill="white"
          transform="translate(0.232056 0.936035)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default Undo
